import { API_ENPOINTS } from '../../constants/api';
import { get, put, post, uploadFile, uploadFiles, requestDelete, downloadBlob } from '../../utils/requests';
import { deserializeCompany, serializeCompany, deserializeReportOptions } from './serializers';

const COMPANY_API = API_ENPOINTS.companyManagement;

export const fetchCompany = (id) => {
  const endpoint = `${COMPANY_API}/${id}`;
  return get(endpoint).then(deserializeCompany);
};

export const fetchCompanies = (page = 1, size = 20, query, enabled) => {
  let endpoint = `${COMPANY_API}?page=${page}&size=${size}`;

  if (query) {
    // We are using encodeURIComponent because query may contains character &
    endpoint = `${endpoint}&query=${encodeURIComponent(query)}`;
  }
  if (typeof enabled === 'boolean') {
    endpoint = `${endpoint}&enabled=${enabled}`;
  }

  return get(endpoint);
};

export const createCompany = (company) => {
  const endpoint = `${COMPANY_API}`;
  return post(endpoint, serializeCompany(company));
};

export const updateCompany = (id, company) => {
  const endpoint = `${COMPANY_API}/${id}`;
  return put(endpoint, serializeCompany(company));
};

export const uploadLogo = (id, file) => {
  const endpoint = `${COMPANY_API}/${id}/UploadLogo`;
  return uploadFile(endpoint, file);
};

export const deleteLogo = (id) => {
  const endpoint = `${COMPANY_API}/${id}/DeleteLogo`;
  return post(endpoint);
};

export const activateCompany = (id) => {
  const endpoint = `${COMPANY_API}/${id}/Activate`;
  return post(endpoint);
};

export const deactivateCompany = (id) => {
  const endpoint = `${COMPANY_API}/${id}/Deactivate`;
  return post(endpoint);
};

export const fetchReportOptions = (id) => {
  const endpoint = `${COMPANY_API}/${id}/ReportOptions`;
  return get(endpoint).then(deserializeReportOptions);
};

export const fetchReportOptionsFromTest = (id) => {
  const endpoint = `${COMPANY_API}/${id}/ReportOptionsFromTest`;
  return get(endpoint).then(deserializeReportOptions);
};

export const updateReportOptions = (id, payload) => {
  const endpoint = `${COMPANY_API}/${id}/ReportOptions`;
  return put(endpoint, payload);
};

export const fetchReportTemplate = (id, layout, reportType) => {
  const endpoint = `${COMPANY_API}/${id}/ReportTemplates/${layout}/${reportType}`;
  return get(endpoint);
};

export const updateReportTemplate = (id, layout, reportType, coverLetter, endOfReport) => {
  const endpoint = `${COMPANY_API}/${id}/ReportTemplates/${layout}/${reportType}`;
  return put(endpoint, {
    coverLetter,
    endOfReport,
  });
};

export const uploadReportAttachment = (id, file, layout, reportType) => {
  const endpoint = `${COMPANY_API}/${id}/ReportTemplates/${layout}/${reportType}/UploadAttachment`;
  return uploadFile(endpoint, file);
};

export const removeReportAttachment = (id, layout, reportType) => {
  const endpoint = `${COMPANY_API}/${id}/ReportTemplates/${layout}/${reportType}/DeleteAttachment`;
  return requestDelete(endpoint);
};

export const downloadReportAttachment = (id, layout, reportType) => {
  const endpoint = `${COMPANY_API}/${id}/ReportTemplates/${layout}/${reportType}/DownloadAttachment`;
  return downloadBlob(endpoint);
};

export const fetchEmailTemplate = (id, reportType) => {
  const endpoint = `${COMPANY_API}/${id}/EmailTemplates/${reportType}`;
  return get(endpoint);
};

export const updateEmailTemplate = (id, reportType, from, subject, body) => {
  const endpoint = `${COMPANY_API}/${id}/EmailTemplates/${reportType}`;
  return put(endpoint, {
    from,
    subject,
    body,
  });
};

export const fetchEmailTemplateKeywords = (id) => {
  const endpoint = `${COMPANY_API}/${id}/EmailTemplateKeywords`;
  return get(endpoint);
};

export const uploadEmailTemplateAttachments = (id, reportType, file) => {
  const endpoint = `${COMPANY_API}/${id}/EmailTemplates/${reportType}/UploadAttachments`;
  return uploadFiles(endpoint, file);
};

export const validateCustomerNumber = (customerNumber) => {
  const endpoint = `${API_ENPOINTS.validate}?customerNumber=${customerNumber}`;
  return get(endpoint);
};

export const prepareEmailPreview = (companyId, subject, body) => {
  const endpoint = `${COMPANY_API}/${companyId}/EmailTemplates/Preview`;
  return post(endpoint, {
    subject,
    body,
  });
};



// WEBPACK FOOTER //
// src/actions/companies/apiRequests.js